import { AUDIT_BASE_URL } from "../../../utils/ApiUrls";

const EXPORT_BASE_URL = `${AUDIT_BASE_URL}/export`;

class ExportQuestionService {
  /**
   * Export audit question as PDF
   * @param {string} accessToken - JWT access token
   * @param {number} questionId - The audit question ID
   */
  async exportQuestionPDF(accessToken, questionId) {
    try {
      const response = await fetch(`${EXPORT_BASE_URL}/question/${questionId}/pdf/`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        const data = await response.json();
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error exporting audit question',
          errorData: data,
        };
      }

      // Get the PDF blob
      const blob = await response.blob();
      
      // Create a download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `audit_question_${questionId}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return {
        success: true,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }
}

const exportQuestionService = new ExportQuestionService();
export default exportQuestionService;
